module.exports = __webpack_public_path__ + "static/media/icon-plus-thin.1da25f58.png";